import React from 'react';
import { Link } from 'react-router-dom';

import { Share2 } from 'lucide-react';
import { trackAction } from '../services/achievementService';

const Footer = () => {
  const footerLinks = [
    { name: 'Hakkımızda', path: '/about' },
    { name: 'Gizlilik & KVKK', path: '/privacy' },
    { name: 'İletişim', path: '/contact' },
    { name: '81 İl Rehberi (Blog)', path: '/blog' }
  ];

  const handleShare = async () => {
    // Başarım Takibi: Topluluk Destekçisi
    trackAction('sharedApp', 'community-supporter').then(unlocked => {
      if (unlocked) {
        alert("Tebrikler! 'Topluluk Destekçisi' başarımını kazandınız! 📣");
      }
    });

    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Say-Hot',
          text: 'Say-Hot ile seyahat planı oluştur!',
          url: window.location.origin,
        });
      } catch (error) {
        console.log('Error sharing:', error);
      }
    } else {
      alert('Tarayıcınız paylaşım özelliğini desteklemiyor. Link kopyalandı!');
      navigator.clipboard.writeText(window.location.origin);
    }
  };

  return (
    <footer className="bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <nav className="flex flex-wrap justify-center -mx-5 -my-2" aria-label="Footer">
          {footerLinks.map((link) => (
            <div key={link.name} className="px-5 py-2">
              <Link to={link.path} className="text-base text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                {link.name}
              </Link>
            </div>
          ))}
          <div className="px-5 py-2">
            <button onClick={handleShare} className="flex items-center text-base text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 font-medium">
              <Share2 size={18} className="mr-1" />
              Say-Hot'ı Paylaş
            </button>
          </div>
        </nav>
        <div className="mt-8 flex justify-center space-x-6">
          {/* Social media icons can go here */}
        </div>
        <p className="mt-8 text-center text-base text-gray-400 dark:text-gray-500">
          &copy; {new Date().getFullYear()} Say-Hot. Tüm hakları saklıdır.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
